import styled from "@emotion/styled/macro";
import { MOBILE_BREAKPOINT } from "@sunrun/experience-ui-components";
import { ReviewOffer } from "../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import { type PromotionSelectionItem } from "services/promotions";
import { SimplifiedOfferReviewPaymentDetails } from "components/organisms/offerReviewPayment/SimplifiedOfferReviewPaymentDetails";

type SimplifiedOfferReviewPaymentSectionProps = {
  offer: ReviewOffer;
  hasBattery: boolean;
  isNewHomes?: boolean;
  promotions?: PromotionSelectionItem[];
  showPromotions?: boolean;
  omitInlineMonthlyAutopayDisclaimer?: boolean;
  hideOfferExpiryFootnote?: boolean;
  showSelfSupplyGraphLink?: boolean;
  onSelfSupplyGraphClick?: () => void;
};

const SimplifiedOfferReviewPaymentSection = ({
  offer,
  hasBattery,
  isNewHomes,
  promotions,
  showPromotions,
  omitInlineMonthlyAutopayDisclaimer,
  hideOfferExpiryFootnote,
  showSelfSupplyGraphLink,
  onSelfSupplyGraphClick,
}: SimplifiedOfferReviewPaymentSectionProps) => {
  return (
    <Section data-testid="simplified-offer-review-payment">
      <SimplifiedOfferReviewPaymentDetails
        financialBreakdown={offer.financial}
        consumption={offer.consumption}
        production={offer.production ?? 0}
        hasBattery={hasBattery}
        products={[...offer.includedProducts, ...offer.accessoryProducts]}
        isNewHomes={isNewHomes}
        promotions={
          showPromotions && promotions?.length ? promotions : undefined
        }
        omitInlineMonthlyAutopayDisclaimer={omitInlineMonthlyAutopayDisclaimer}
        hideOfferExpiryFootnote={hideOfferExpiryFootnote}
        showSelfSupplyGraphLink={showSelfSupplyGraphLink}
        onSelfSupplyGraphClick={onSelfSupplyGraphClick}
      />
    </Section>
  );
};

const Section = styled.section`
  box-sizing: border-box;
  max-width: 1200px;
  width: calc(100% - 128px);
  margin: 0 auto 48px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: calc(100% - 32px);
  }
`;

export { SimplifiedOfferReviewPaymentSection };
